export default {
    view: String,
    hidden: {
        type: Boolean,
        default: false
    }
}
